<!--
 * @Author: fusanqiasng
 * @Date: 2022-10-20 15:56:50
 * @LastEditors: fusanqiasng
 * @LastEditTime: 2022-11-02 18:16:26
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div class="manager_container">
    <div class="manager_top">
      <div class="manager_header">
        <span class="">选择学管师</span>
        <img class="btn_close" src="https://image.xiaomaiketang.com/xm/HFYSBYmf2C.png" @click="cancel" />
      </div>
      <yd-search v-model="searchValue" @input="debounceSearch" placeholder="搜索学管师" :on-cancel="handleCancel"></yd-search>
    </div>
    <div class="manager_body" style="margin-top: 2rem">
      <div class="manager_result">
        <div class="check-list" style="margin-bottom: 2rem;" v-if="managerList.length > 0">
          <van-radio-group v-model="selectedManagerId">
            <van-radio v-for="item in managerList" class="check-item" :key="item.id" :name="item.id" label-position="left">{{
              item.nickName ? item.nickName : desensitizeName(item.adminName) + '(' + item.accountNo.slice(7, 11) + ')'
            }}</van-radio>
          </van-radio-group>
        </div>
        <xm-empty-page v-else src="https://image.xiaomaiketang.com/xm/JypYkCQChP.png" title="暂无学管师" />
      </div>
    </div>
    <div class="manager_footer" style="background:#ffffff">
      <button v-if="managerList.length" class="btn_cancel" @click="handleClear" style="background:#ffffff">暂不选择</button>
      <button class="btn_confirm" @click="confirm" :style="{ width: managerList.length ? '3.2rem' : '100%' }">确定</button>
    </div>
  </div>
</template>
<script>
import EmptyDataPage from '@/module/base/EmptyDataPage';
export default {
  components: {
    'xm-empty-page': EmptyDataPage,
  },
  props: {
    managerId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      searchValue: '',
      canLoad: false, // 是否还可以加载数据
      // selectedManagerId: this.managerId || 0,
      selectedManagerId: this.managerId,
      recordList: [],
      loading: false,
      managerList: [],
      checked: [],
      debounceSearch: () => {},
    };
  },
  mounted() {
    this.fetchManagerList();
    this.debounceSearch = _.debounce(() => {
      this.fetchManagerList('input');
    }, 500);
  },
  methods: {
    fetchManagerList() {
      const { searchValue } = this;
      let data = {
        instId: window.getParameterByName('instId'),
        commodityId: window.getParameterByName('commodityId'),
        nameLike: searchValue,
      };
      return axios.Customer('public/mall/fetchCommodityManagerList', data).then(res => {
        if (res.success) {
          this.managerList = res.result;
        }
      });
    },
    desensitizeName(str) {
      if (null != str && str != undefined) {
        if (this.isEmojiCharacter(str)) {
          return str;
        } else {
          if (str.length <= 2) {
            return str.substring(0, 1) + '*';
          } else {
            return str.substring(0, 1) + '*' + str.substring(str.length - 1);
          }
        }
      }
    },
    isEmojiCharacter(substring) {
      for (var i = 0; i < substring.length; i++) {
        var hs = substring.charCodeAt(i);
        if (0xd800 <= hs && hs <= 0xdbff) {
          if (substring.length > 1) {
            var ls = substring.charCodeAt(i + 1);
            var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
            if (0x1d000 <= uc && uc <= 0x1f77f) {
              return true;
            }
          }
        } else if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1);
          if (ls == 0x20e3) {
            return true;
          }
        } else {
          if (0x2100 <= hs && hs <= 0x27ff) {
            return true;
          } else if (0x2b05 <= hs && hs <= 0x2b07) {
            return true;
          } else if (0x2934 <= hs && hs <= 0x2935) {
            return true;
          } else if (0x3297 <= hs && hs <= 0x3299) {
            return true;
          } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b || hs == 0x2b50) {
            return true;
          }
        }
      }
      return false;
    },
    // 清空搜索条件
    handleCancel() {
      this.searchValue = '';
      this.fetchManagerList();
    },
    // 暂不选择
    handleClear() {
      // this.$emit('confirm', {});
      this.$emit('confirm', 0);
      this.cancel();
    },
    // 关闭弹窗
    cancel() {
      this.$emit('cancel');
    },
    // 确认
    confirm() {
      if (this.selectedManagerId) {
        this.$emit('confirm', this.selectedManagerId);
        // this.$emit('confirm', this.selectedManager);
        this.cancel();
      } else {
        Vue.$wheatToast('请选择学管师');
      }
    },
  },
};
</script>
<style lang="less" >
@import '../../core/mixins.less';


      .manager_container {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
        overflow: hidden;
        .manager_top {
          z-index: 99;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          .yd-search {
            .yd-search-input {
              background: #ffffff;
              .search-input {
                background: #f7f7f7;
              }
            }
            .-text {
              color: #999;
            }
          }
        }
        .manager_header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.24rem 0.32rem;
          background: #ffffff;
          .btn_close {
            width: 0.42rem;
            height: 0.42rem;
          }
        }
        .manager_body {
          display: flex;
          flex-direction: column;
          height: 100%;
          .manager_result {
            position: relative;
            height: 100%;
            overflow: auto;
            .scroll-inner {
              top: 0;
            }
            .check-list {
              margin: 0 0.36rem;
              .check-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 0.88rem;
                border-bottom: 0.01rem #ebedf0 solid;
              }
            }
            .result_list {
              height: 100%;
              .result_item {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0.24rem 0.32rem;
                text-align: left;
                border-bottom: 0.02rem solid #eee;
                .item_left {
                  .class_title {
                    width: 100%;
                    font-size: 0.32rem;
                    font-weight: bold;
                    .text-overflow-ellipsis-line(2);
                  }
                  .remain_number,
                  .teacher_name {
                    margin-top: 0.14rem;
                    font-size: 0.3rem;
                    color: #999;
                  }
                }
                .item_right {
                  position: relative;
                  text-align: right;
                  flex: 0 0 3rem;
                  img {
                    width: 0.32rem;
                    height: 0.32rem;
                  }
                }
                .status {
                  position: absolute;
                  width: 1.5rem;
                  text-align: center;
                  bottom: 0.3rem;
                  right: 0.1rem;
                  color: #ff6934;
                  font-size: 0.26rem;
                }
              }
            }
            .empty-data-page {
              background: #ffffff;
            }
          }
        }
        .manager_footer {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 0.24rem 0.38rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ffffff;
          z-index: 999;
          button {
            width: 3.2rem;
            height: 1.05rem;
            line-height: 1.05rem;
            font-size: 0.3rem;
            border-radius: 5px;
            border: 0 none;
          }
          .btn_cancel {
            color: #ff6934;
            border: 1px solid #ff6934;
          }
          .btn_confirm {
            color: #ffffff;
            background-image: linear-gradient(to right, #ff7819, #ff4200);
          }
        }
      }
 

</style>



// WEBPACK FOOTER //
// src/module/mall/AddManager.vue